// import Vue from 'vue'
import API from '@/api';
export function isEmptyObj (object) {
  let item
  for (item in object) {
    return false
  }
  return true
}
export function downloadById (id) {
  API.getDownloadcontentInfo({ id }).then(res => {
    API.getDownloadcontentFile({
      fileId: res.data.fileId,
      version: res.data.version
    })
      .then(res => {
        let link = document.createElement('a')
        let body = document.querySelector('body')
        link.href = res.data.url
        link.download = res.data.filename
        // fix Firefox
        link.style.display = 'none'
        body.appendChild(link)
        link.click()
        body.removeChild(link)
        window.URL.revokeObjectURL(link.href)
      })
  })
}

export function downloadFile (url, filename, type = 'file') {
  if (type == 'file') {
    saveAs(url, filename)
  } else if (type == 'base64') {
    let blob = base64ToBlob(url);
    saveAs(blob, filename)
  }
  function base64ToBlob (base64) {
    let parts = base64.split(';base64,');
    let contentType = parts[0].split(':')[1];
    let raw = window.atob(parts[1]);
    let rawLength = raw.length;

    let uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], {
      type: contentType
    });
  }

  function saveAs (blob, filename) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename)
    } else {
      let link = document.createElement('a')
      let body = document.querySelector('body')

      link.href = window.URL.createObjectURL(blob)
      link.download = filename

      // fix Firefox
      link.style.display = 'none'
      body.appendChild(link)

      link.click()
      body.removeChild(link)

      window.URL.revokeObjectURL(link.href)
    }
  }
}
export function telSecret (str) {
  if (str && str.length > 10) {
    str = str.substr(0, 3) + '****' + str.substr(-4, 4)
  }
  return str
}
export function IdNoSecret (str) {
  if (str && str.length > 10) {
    str = str.substr(0, 6) + '*********' + str.substr(-3, 3)
  }
  return str
}
// 动态修改自动定义颜色
export const setCssVar = (prop, val, dom = document.documentElement) => {
  dom.style.setProperty(prop, val)
}
export const setCssVarRGB = (hexStr) => {
  // 空值直接返回空数组，避免 undefined.toLowerCase() 抛错中断调用方
  if (!hexStr) return []
  //rgb颜色值的正则表达式
  const reg = /^(rgba|rgb|RGBA|RGB)\([\s]*[0-9]+[\s]*,[\s]*[0-9]+[\s]*,[\s]*[0-9]+[\s]*(,[\s]*[0-9.]+[\s]*)*\)$/
  if (reg.test(hexStr)) {
    return hexStr
  } else {
    hexStr = hexStr.toLowerCase()
    if (hexStr.length === 4) {
      let colorNew = "#"
      for (let i = 1; i < 4; i += 1) {
        const str = hexStr.slice(i, i + 1); colorNew += str + str
      }
      hexStr = colorNew
    }
    const rgbArray = []
    for (let i = 1; i < hexStr.length; i += 2) {
      if (i < 7) {
        rgbArray.push(parseInt("0x" + hexStr.slice(i, i + 2)))
      }
    }
    return rgbArray
  }
}
export const storeMaker = (state) => {
  // 初始化
  Object.keys(state).map((key) => {
    // 判断类型获取本地存储数据
    if (typeof state[key] === 'object') {
      if (sessionStorage.getItem(key) && JSON.parse(sessionStorage.getItem(key))) {
        state[key] = JSON.parse(sessionStorage.getItem(key))
      }
    } else if (typeof state[key] === 'number') {
      if (sessionStorage.getItem(key) && parseInt(sessionStorage.getItem(key))) {
        state[key] = parseInt(sessionStorage.getItem(key))
      }
    } else {
      if (sessionStorage.getItem(key)) {
        state[key] = sessionStorage.getItem(key)
      }
    }
  })

  // 重写set处理
  return new Proxy(state, {
    set: function (target, key, value) {
      let temp = value
      if (typeof temp === 'object') {
        temp = JSON.stringify(temp)
      }

      sessionStorage.setItem(key, temp)
      return Reflect.set(target, key, value)
    }
  })
}